export class S3SampleFileRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "credentialsProfileId",
            "baseName": "credentialsProfileId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "s3Uri",
            "baseName": "s3Uri",
            "type": "string",
            "format": ""
        },
        {
            "name": "formatHint",
            "baseName": "formatHint",
            "type": "string",
            "format": ""
        },
        {
            "name": "sampleRows",
            "baseName": "sampleRows",
            "type": "number",
            "format": ""
        },
        {
            "name": "maxBytes",
            "baseName": "maxBytes",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return S3SampleFileRequest.attributeTypeMap;
    }
    constructor() {
    }
}
